define(["exports", "react", "styled-components", "../../utils", "../Highlight"], function (_exports, _react, _styledComponents, _utils, _Highlight) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.FormatText = void 0;
  _react = _interopRequireDefault(_react);
  _styledComponents = _interopRequireDefault(_styledComponents);
  _Highlight = _interopRequireDefault(_Highlight);

  var BlockText = _styledComponents.default.span.withConfig({
    displayName: "FormatText__BlockText",
    componentId: "sc-aqmlrm-0"
  })(["display:block;"]);

  var FormatText = function FormatText(_ref) {
    var texts = _ref.texts,
        searchWords = _ref.searchWords;
    return texts.split('\n').map(function (text) {
      return /*#__PURE__*/_react.default.createElement(BlockText, {
        key: (0, _utils.uniqueId)()
      }, /*#__PURE__*/_react.default.createElement(_Highlight.default, {
        textToHighlight: text.replace(/\s/g, ' '),
        searchWords: searchWords
      }));
    });
  };

  _exports.FormatText = FormatText;
});